import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Col, Container, FormGroup, Input, Row, Spinner } from 'reactstrap';
import moment from 'moment';
import Select from 'react-select';

//Services
import { api_GET, api_POST } from '../../../services/api_service';
import { showMessage } from '../../../services/message';

//CSS
import "../../../assets/css/loading.css";

//Helpers
import { formateDateApi } from '../../../helpers/formats';
import MaterialTable from 'material-table';

//Components
import HistoricoLocalExecucoes from './HistoricoLocalExecucoes';

//Constants
import { table_translate, table_style } from '../../../constants/MaterialTable';

function HistoricoList({ history }) {

    const { register, errors, setValue, clearErrors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = useState(false);
    const [list_loading, set_list_loading] = useState(false);

    const [listLocaisColeta, setListLocaisColeta] = useState([]);

    const [inicio, setInicio] = useState(formateDateApi(moment().subtract(1, 'month')));
    const [fim, setFim] = useState(formateDateApi(moment(new Date())));

    //State para mostrar as informaçoes de execucões
    const [historicoLocalExecucao, setHistoricoLocalExecucao] = useState(null);

    const columnsProp = [
        { title: 'Identificação', field: 'identificacao' },
        { title: 'Endereço', field: 'endereco' }
    ]

    // Modalidade
    const [optionsModalidadesColeta, setoptionsModalidadesColeta] = useState([]);
    const [modalidadeColeta, setModalidadeColeta] = useState(null);
    const loadOptionsModalidadesColeta = () => {
        api_GET(`modalidadeColeta`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setoptionsModalidadesColeta(result.data);
            }
        });
    }

    const [optionsRegional, setOptionsRegional] = useState([]);
    const [regional, setRegional] = useState(null);
    const loadOptionsRegional = () => {
        api_GET(`regional`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                setOptionsRegional(result.data);
            }
        });
    }

    const [optionsAreaOperacionais, setOptionsAreaOperacionais] = useState([]);
    const [areaOperacional, setAreaOperacional] = useState(null);
    const loadOptionsAreaOperacionaisByModalidade = () => {
        setshowLoading(true);
        api_GET(`Territorio/GetListByRegional/${regional.regionalId}`).then(result => {
            result.data.map(value => {
                value.label = value.descricao;
                value.value = value.territorioId;
                return value;
            })
            setOptionsAreaOperacionais(result.data)
        }).catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setshowLoading(false));
    }

    const handleModalidadesColeta = (event) => {
        let value = event;
        setModalidadeColeta(value);
        clearErrors("modalidadeColeta");
    }

    const handlePontoColeta = () => {
        if (modalidadeColeta == null) {
            showMessage("Aviso", "Por favor, selecione uma modalidade!", "warning", null);
            return;
        }
        if (regional == null) {
            showMessage("Aviso", "Por favor, selecione uma divisão administrativa!", "warning", null);
            return;
        }

        const json_submit = {
            modalidadeColetaId: modalidadeColeta.modalidadeColetaId,
            regionalId: regional.regionalId,
            territorioId: areaOperacional != null ? areaOperacional.territorioId : 0
        }

        set_list_loading(true);
        api_POST("Historico/GetListLocaisExecucao", json_submit)
            .then(result => {
                set_list_loading(false);
                setshowLoading(false);
                if (result.status != 200) {
                    showMessage("Aviso", "Erro na operação.", 'error', null);
                    return;
                } else {
                    setListLocaisColeta(result.data);
                }
            });
    }

    const handlePesquisarLocal = ({ pontoColetaId }) => {
        const json_submit = {
            dataInicio: inicio,
            dataFim: fim,
            modalidadeColetaId: modalidadeColeta.modalidadeColetaId,
            pontoColetaId: pontoColetaId
        };

        setshowLoading(true);
        api_POST("Historico/GetLocalExecucoes", json_submit)
            .then(result => {
                setshowLoading(false);
                if (result.status != 200) {
                    showMessage("Aviso", "Não existe registro de execução para o local e período informados.", 'error', null);
                    return;
                } else {
                    if (!!result.data) {
                        setHistoricoLocalExecucao(result.data);
                    }
                }
            });
    }

    useEffect(() => {
        setValue("dataInicio", inicio);
        setValue("dataFim", fim);
        loadOptionsModalidadesColeta();
        loadOptionsRegional();
    }, []);

    useEffect(() => {
        if (regional != null) {
            loadOptionsAreaOperacionaisByModalidade();
            setAreaOperacional(null);
        }
    }, [regional]);

    const handleReturn = () => {
        setValue("dataInicio", inicio);
        setValue("dataFim", fim);
        setHistoricoLocalExecucao(null);
    }

    return <>
        {showLoading &&
            <div className="carregandoCmp">
                <div className="box">
                    <label style={{ marginRight: "20px" }}>Carregando...</label>
                    <Spinner size="sm" color="info" />
                </div>
            </div>
        }
        {historicoLocalExecucao == null &&
            <>
                <div className="header bg-gradient-info pb-4 pt-5 pt-md-7 no-print">
                    <Container fluid>
                        <div className="header-body">
                            <Row>
                                <Col md="12" lg="2">
                                    <FormGroup>
                                        <label className="form-control-label text-white" htmlFor="input-address" >
                                            Data Início
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            innerRef={register({ required: true })}
                                            defaultValue={inicio ? formateDateApi(inicio) : ""}
                                            name="dataInicio"
                                            placeholder="Data Início"
                                            type="date"
                                            max={formateDateApi(moment(new Date()))}
                                            onBlur={(e) => setInicio(formateDateApi(e.target.value))}
                                        />
                                        {errors.dataInicio && <span className="form-control-label text-white">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="12" lg="2">
                                    <FormGroup>
                                        <label className="form-control-label text-white" htmlFor="input-address" >
                                            Data Fim
                                        </label>
                                        <Input
                                            className="form-control-alternative"
                                            innerRef={register({ required: true })}
                                            defaultValue={fim ? formateDateApi(fim) : ""}
                                            name="dataFim"
                                            placeholder="Data Fim"
                                            type="date"
                                            max={formateDateApi(moment(new Date()))}
                                            onBlur={(e) => setFim(formateDateApi(e.target.value))}
                                        />
                                        {errors.dataFim && <span className="form-control-label text-white">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="12" lg="4">
                                    <FormGroup>
                                        <label className="form-control-label text-white" htmlFor="input-address" >
                                            Modalidade de Serviço
                                        </label>
                                        <Select
                                            name="modalidadeColeta"
                                            options={optionsModalidadesColeta}
                                            getOptionLabel={({ descricao }) => descricao}
                                            getOptionValue={({ modalidadeColetaId }) => modalidadeColetaId}
                                            onChange={(value) => { handleModalidadesColeta(value) }}
                                            value={modalidadeColeta != null && optionsModalidadesColeta.find(obj => obj.modalidadeColetaId === modalidadeColeta.modalidadeColetaId)}
                                            placeholder="Selecione"
                                        />
                                        {errors.modalidadeColeta && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="12" lg="4">
                                    <FormGroup>
                                        <label className="form-control-label text-white" htmlFor="input-address" >
                                            Divisão Administrativa
                                        </label>
                                        <Select
                                            name="regional"
                                            options={optionsRegional}
                                            getOptionLabel={({ descricao }) => descricao}
                                            getOptionValue={({ regionalId }) => regionalId}
                                            onChange={(value) => { setRegional(value) }}
                                            value={regional != null && optionsRegional.find(obj => obj.regionalId === regional.regionalId)}
                                            placeholder="Todas"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="12" lg="4">
                                    <FormGroup>
                                        <label className="form-control-label text-white" htmlFor="input-address" >
                                            Área Operacional
                                        </label>
                                        <Select
                                            name="areaOperacional"
                                            options={optionsAreaOperacionais}
                                            getOptionLabel={({ descricao }) => descricao}
                                            getOptionValue={({ territorioId }) => territorioId}
                                            onChange={(value) => { setAreaOperacional(value) }}
                                            value={areaOperacional && optionsAreaOperacionais.find(x => x.territorioId == areaOperacional.territorioId)}
                                            placeholder="Selecione"
                                        />
                                    </FormGroup>
                                </Col>

                                <Col md="3" lg="2" xl="2" className="pt-2">
                                    <br />
                                    <Button color="secondary" type="button" onClick={() => handlePontoColeta()}>Pesquisar</Button>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </div>
                <Container fluid style={{ marginTop: "-25px" }}>
                    <div className="row" >
                        <div lg="12" className="col-lg-12  mb-3" >
                            <div className="card card-stats mb-4 mb-xl-0">
                                <MaterialTable
                                    title="Lista de Locais de Execução"
                                    columns={columnsProp}
                                    data={listLocaisColeta}
                                    isLoading={list_loading}
                                    options={{ ...table_style, headerStyle: { zIndex: 0 } }}
                                    actions={[
                                        {
                                            icon: 'search',
                                            tooltip: 'pesquisar local de execução',
                                            onClick: (event, rowData) => handlePesquisarLocal(rowData)
                                        }
                                    ]}
                                    localization={table_translate}
                                />
                            </div>

                        </div>
                    </div>

                </Container>
            </>
        }

        {historicoLocalExecucao &&
            <HistoricoLocalExecucoes
                historicoLocalExecucao={historicoLocalExecucao}
                handleReturn={handleReturn}
                dataPesquisa={{ dataInicio: inicio, dataFim: fim }}
            />
        }

    </>;
}

export default HistoricoList;